import { AppBuildTheme } from '../types/appBuildTheme'

const theme = (process?.env?.theme || window?.ENV?.theme || 'billy') as AppBuildTheme

export const getAppBuildTheme = (): AppBuildTheme => theme
